<template>
<div class="good flex align-center justify-center" @touchmove.prevent @scroll.stop.prevent>
    <div class="good-main flex-column">
        <div class="flex align-center justify-space-between p-30">
          <div class="font-16 color-292a2e font-yahei">商品列表</div>
            <img src="/images/guanbi.png" alt="" @click="onCloseAdd" class="cursor">
        </div>
        <div class="hr"></div>
        <div class="flex-1 p-30" style="overflow-y:scroll;">
             <div class="flex flex-wrap" style="align-items: stretch;">
                <div class="item mb-20" :class="index%3 === 0 ? '' : 'ml-20'" v-for="(item, index) in goodsList" :key="index">
                    <div class="pic">
                    <el-image :src="Utils.IMG_PREV + item.goodsPicList[imgIndex].pic" fit="cover" class="w-100 h-100"></el-image>
                    <div class="mask" :class="isSwitch ? 'bg-eeeff3' : 'bg-transparent'"></div>
                    <div class="imgList flex align-center">
                        <div class="img-item cursor mr-5" :style="{background:'url(' + Utils.IMG_PREV + itemImg.pic + ') no-repeat center/cover'}" v-for="(itemImg, indexImg) in item.goodsPicList" :key="indexImg" @mouseenter="onImg(indexImg)">
                        <div class="w-100 h-100" :class="index === imgIndex ? 'bg-c19357-5' : ''"></div>
                        </div>
                    </div>
                    </div>
                    <div class="bottom">
                    <div class="color-ff font-16 font-yahei mb-6">{{item.name}}</div>
                    <span v-if="item.isShow"></span>
                    <div class="flex align-center mb-28">
                        <span class="font-18 color-c19357 font-arial mr-10">¥{{Utils.toFixedNum(item.isPeferential == 1 ? item.summaryPreferentialPrice : item.summaryPrice)}}</span>
                        <span class="linethrough color-ca font-12 font-arial" v-if="item.isPeferential">¥{{Utils.toFixedNum(item.summaryPrice)}}</span>
                    </div>
                    <!-- <div class="flex align-end" style="height:100px;overflow:hidden"> -->
                        <!-- <div class="font-12 color-94">
                            <div class="flex align-center mb-4" v-for="(item,index) in item.goodsAttributeList" :key="index">{{item.standard}}<div class="w-130 text-overflow ml-10">{{item.value}}</div></div>
                            <div class="flex align-center">编码<div class="w-130 text-overflow ml-10">{{item.number}}</div></div>
                        </div> -->
                        <div class="flex align-start mb-10" v-for="(item1, standIndex) in item.goodsStandardList" :key="standIndex">
                          <span class="font-12 color-94 w-70 mr-15">{{item1.name}}</span>
                          <div class="flex-1 w-0 flex flex-wrap">
                            <div @click="selectAttribute(index,standIndex,cellIndex,cellItem)" v-for="(cellItem, cellIndex) in item1.goodsAttributeList" :key="cellIndex" class="radius-round font-12 mr-5 mb-5" style="padding:2px 6px" :class="cellItem.status == -1 ? 'color-ff linethrough border-ff':cellItem.selected ? 'color-c19357 bg-f6efe6' : 'color-292a2e bg-eeeff3'">
                              {{cellItem.value}}
                            </div>
                          </div>
                        </div>
                        <div class="flex-1 text-right justify-end">
                          <el-input-number v-model="item.quantity" :min="1"></el-input-number>
                        </div>
                        <!-- <div>
                            <div class="btn-30 radius-round mb-20 selectBtn">选择商品规格</div>
                            <el-input-number v-model="item.quantity" :min="1"></el-input-number>
                        </div> -->
                    <!-- </div> -->
                    </div>
                    <div class="operate" v-if="!item.isEmpty">
                      <img :src="item.isSelect ? '/images/xuan-xz.png' : '/images/xuan.png'" alt="" class="cursor" @click="chooseGood(index)">
                    </div>
                    <div v-else class="wuhuo-Icon">
                      <img src="/images/wuhuoshangpin.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="p-20">
            <el-pagination layout="prev, pager, next" :page-size="15" :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>
        
  </div>
  </div>
</template>

<script>

export default {
  name: "Index",
  components: {},
  props: ['currentSpace'],
  data () {
    return {
      num: 0,
      isSelect: false,
      imgIndex: 0,
      isSwitch: false,
      page:1,
      limit: 15,
      total:0,
      goodsList: []
    }
  },
  created () {
      this.getGoods()
  },
  mounted () {
  },
  methods: {
    getGoods () {
      this.goodsList = []
      let params = {
        spaces: this.currentSpace.name,
        keywords: this.keywords,
        limit: this.limit,
        page: this.page
      }
      this.axios.post(`goods/queryForPage`, params).then(res => {
        if (res.data.success) {
          let list = res.data.data.list
          for (let i=0;i<list.length;i++) {
              let currentPrice = 0
              let selectAttribute = []
              if (list[i].goodsStandardList.length>0) {
                for (let j=0;j<list[i].goodsStandardList.length;j++) {
                  let hasFlag = false
                  if (list[i].goodsStandardList[j].goodsAttributeList && list[i].goodsStandardList[j].goodsAttributeList.length>0) {
                    for (let r=0;r<list[i].goodsStandardList[j].goodsAttributeList.length;r++) {
                      if (list[i].goodsStandardList[j].goodsAttributeList[r].status == 1) {
                        list[i].goodsStandardList[j].goodsAttributeList[r].selected = true
                        hasFlag = true
                        currentPrice = currentPrice +  list[i].goodsStandardList[j].goodsAttributeList[r].priceRevision
                        let item = list[i].goodsStandardList[j].goodsAttributeList[r]
                        item.standard = list[i].goodsStandardList[j].name
                        selectAttribute.push(item)
                        break
                      }
                    }
                  }
                   if(!hasFlag){
                    list[i].isEmpty = 1
                  }
                }
              }
              // console.log(selectAttribute)
              // if (selectAttribute.length == 0) {
              //   list[i].isEmpty = 1
              // }
              list[i].newAttributeList = selectAttribute
              list[i].summaryPreferentialPrice =  list[i].preferentialPrice + currentPrice
              list[i].summaryPrice = list[i].price + currentPrice
              list[i].quantity = 1
              list[i].isSelect = false
              list[i].isShow = false
              // list[i].summaryPrice = list[i].isPeferential ? list[i].preferentialPrice : list[i].price
              // list[i].summaryPreferentialPrice = list[i].preferentialPrice
          }
          this.goodsList = list
          this.total = res.data.data.total
        }
      })
    },
    // 选择商品
    chooseGood (index) {
        if (this.currentSpace.programmeSpaceGoodsList.length >0) {
            for (let i=0;i<this.currentSpace.programmeSpaceGoodsList.length;i++) {
                if (this.currentSpace.programmeSpaceGoodsList[i].goodsId == this.goodsList[index].id) {
                    this.$message({
                        message: `${this.goodsList[index].name}已存在`,
                        type: "warn",
                        offset: 400
                    });
                    return
                }
            }
            if (this.goodsList[index].newAttributeList && this.goodsList[index].newAttributeList.length == this.goodsList[index].goodsStandardList.length) {
               this.goodsList[index].isSelect = !this.goodsList[index].isSelect
                if (this.goodsList[index].isSelect) {
                    // this.goodsList[index].programmeSpaceAttributeList = this.goodsList[index].newAttributeList
                    this.goodsList[index].goodsId = this.goodsList[index].id
                    this.goodsList[index].price = this.goodsList[index].newPrice
                    this.goodsList[index].isNew = true
                    this.currentSpace.programmeSpaceGoodsList.push(this.goodsList[index])
                    this.$emit('on-add')
                    this.$message({
                        message: `${this.goodsList[index].name}已加入房间`,
                        type: "success",
                        offset: 400
                    });
                }
            } else {
              this.$message({
                message: `请选择商品属性`,
                type: "warn",
                offset: 400
              });
            }
        } else {
           if (this.goodsList[index].newAttributeList && this.goodsList[index].newAttributeList.length == this.goodsList[index].goodsStandardList.length) {
               this.goodsList[index].isSelect = !this.goodsList[index].isSelect
                if (this.goodsList[index].isSelect) {
                    // this.goodsList[index].programmeSpaceAttributeList = this.goodsList[index].goodsAttributeList
                    this.goodsList[index].goodsId = this.goodsList[index].id
                    this.goodsList[index].price = this.goodsList[index].newPrice
                    this.goodsList[index].isNew = true
                    this.currentSpace.programmeSpaceGoodsList.push(this.goodsList[index])
                    this.$emit('on-add')
                    this.$message({
                      message: `${this.goodsList[index].name}已加入房间`,
                      type: "success",
                      offset: 400
                    });
                }
            } else {
              this.$message({
                message: `请选择商品属性`,
                type: "warn",
                offset: 400
              });
            }
        }
    },
    // 选择属性
    selectAttribute (index, standIndex, tagIndex, item) {
      if (item.status == -1) {
        return
      }
      let selectAttribute = []
      for (let i=0;i<this.goodsList[index].goodsStandardList[standIndex].goodsAttributeList.length;i++) {
        this.goodsList[index].goodsStandardList[standIndex].goodsAttributeList[i].selected = false
      }
      this.goodsList[index].goodsStandardList[standIndex].goodsAttributeList[tagIndex].selected = !this.goodsList[index].goodsStandardList[standIndex].goodsAttributeList[tagIndex].selected
      this.goodsList[index].isShow = !this.goodsList[index].isShow
      let currentPrice = 0
      for (let n=0;n<this.goodsList[index].goodsStandardList.length;n++) {
        for (let m=0;m<this.goodsList[index].goodsStandardList[n].goodsAttributeList.length;m++) {
        if (this.goodsList[index].goodsStandardList[n].goodsAttributeList[m].selected) {
          currentPrice = currentPrice + this.goodsList[index].goodsStandardList[n].goodsAttributeList[m].priceRevision
          //  + this.goodsList[index].goodsStandardList[standIndex].goodsAttributeList[m].settlementPriceRevision
        }
      }
      }
      this.goodsList[index].summaryPrice = this.goodsList[index].price + currentPrice
      this.goodsList[index].summaryPreferentialPrice = this.goodsList[index].preferentialPrice + currentPrice
      for (let p=0;p<this.goodsList[index].goodsStandardList.length;p++) {
        for (let q=0;q<this.goodsList[index].goodsStandardList[p].goodsAttributeList.length;q++) {
          if (this.goodsList[index].goodsStandardList[p].goodsAttributeList[q].selected) {
            let item = this.goodsList[index].goodsStandardList[p].goodsAttributeList[q]
            item.standard = this.goodsList[index].goodsStandardList[p].name
            selectAttribute.push(item)
          }
        }
      }
      this.goodsList[index].newAttributeList = selectAttribute
    },
    onCloseAdd () {
        this.$emit('on-colse')
    },
    handleCurrentChange (e) {
      // console.log(e)
      this.page = e
      this.getGoods()
    },
    onImg (e) {
      this.imgIndex = e
    },
    onDelete () {
      this.$emit('delete', this.index)
    }
  },
  watch: {
    imgIndex (e) {
      this.isSwitch = true
      setTimeout(() => {
        this.isSwitch = false
      }, 300)
    }
  }
};
</script>

<style lang="scss" scoped>
 .good{
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
  }
  .good-main{
    width: 1115px;
    height: 70%;
    background: #fff;
    border-radius: 4px;
  }
  .p-20{
      padding: 20px;
  }
  .border-ff{
    border: 1px solid #ffffff;
  }
  .item{
    width: 335px;
    position: relative;
    .pic{
      height: 220px;
      border-radius: 4px;
      overflow: hidden;
      position: relative;
      .imgList{
        position: absolute;
        z-index: 9;
        bottom: 10px;
        left: 30px;
        .img-item{
          width: 40px;
          height: 26px;
          border: 1px solid #292a2e;
          border-radius: 4px;
          overflow: hidden;
        }
      }
    }
    .mask{
      height: 220px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 8;
      transition: all 1.5s ease;
    }
    .bottom{
      // height: 205px;
      border-radius: 4px;
      overflow: hidden;
      background: #292a2e;
      padding: 26px 28px 28px;
    }
    .operate{
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 9;
    }
     .selectBtn{
      color: #292a2e;
      font-size: 12px;
      width: 88px;
      background: #eeeff3;
      &:hover{
        background: #c19357;
        color: #fff;
      }
    }
  }
  .w-130{
    width: 130px;
  }

  ::v-deep{
    .el-input__inner{
      height: 30px;
      line-height: 30px;
    }
    .el-input-number .el-input__inner{
      padding: 0 30px;
    }
    .el-input-number{
      width: 90px;
      line-height: 30px;
      border-radius: 20px;
      overflow: hidden;
      .el-input__inner{
        background: rgba($color: #000000, $alpha: 0.4);
        border: 0;
        color: #fff;
      }
    }
    .el-input-number__decrease, .el-input-number__increase{
      width: 30px;
      height: 30px;
      top: 0;
      border: 0;
      background: transparent;
      color: #7d7d7d;
      font-weight: bold;
    }
    .el-input-number__decrease{
      left: 0;
    }
    .el-input-number__increase{
      right: 0;
    }
  }
  .wuhuo-Icon{
    position: absolute;
    top: 0;
    left: 0;
  }
</style>
